// Canonical "verdieping" (floor) keys — MUST match the x_studio_verdieping
// selection on project.task in Odoo. Mirror of portal-api/src/utils/verdieping.ts
// — keep in sync.
export const VERDIEPING_KEYS = [
  '-02', '-01', '+00', '+01', '+02', '+03', '+04', '+05', '+06', '+07',
  '+08', '+09', '+10', '+11', '+12', '+13', '+14',
] as const;

// Normalise a raw floor string ("Niv. +00", "Niveau -1", "0", "+3") to a
// canonical key like "+00". Returns '' when nothing valid can be derived.
export function normaliseVerdieping(raw: string): string {
  if (!raw) return '';
  const match = raw.match(/([+-]?)\s*0*(\d{1,2})/);
  if (!match) return '';
  const sign = match[1] === '-' ? '-' : '+';
  const key = `${sign}${match[2].padStart(2, '0')}`;
  return (VERDIEPING_KEYS as readonly string[]).includes(key) ? key : '';
}
